// extracted by mini-css-extract-plugin
module.exports = {"title":"BrandsSidebar_title__r2xhX","letter":"BrandsSidebar_letter__7iYke"};